<template>
    <div class="d-flex align-center mb-4">
        <div class="text-meta flex-grow-0 text-secondary font-weight-medium">{{label}}</div>
        <div class="bg-secondary flex-grow-1 ms-2" style="height:1px"></div>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            default: null
        }
    }
}
</script>
